import React from 'react'
import PropTypes from 'prop-types'
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Flex,
    Radio,
    RadioGroup,
    Text,
    VStack,

    /* Hooks */
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {ChevronDownType2} from '../../../components/icons'

const DrawerSort = ({sortingOptions = [], sortUrls, selectedSortingOption}) => {
    const history = useHistory()
    const refinementsStyles = useMultiStyleConfig('Refinements')

    const selectedSortLabel =
        sortingOptions.find((option) => option.id === selectedSortingOption)?.label || ''

    if (!sortUrls?.length) return null

    return (
        <>
            <Accordion allowToggle defaultIndex={[]} reduceMotion={false} variant={'filter'}>
                <AccordionItem
                    {...refinementsStyles.sbAccItem}
                >
                    {({isExpanded}) => (
                        <>
                            <AccordionButton paddingTop={0} paddingBottom={isExpanded ? 2 : 0}>
                                <Text {...refinementsStyles.accTitle}>
                                    <FormattedMessage
                                        id="product_list.drawer.title.sort_by"
                                        defaultMessage="Sort By"
                                    />
                                </Text>
                                <Flex align="center" gap={3}>
                                    <Text {...refinementsStyles.sbSelectedLabel}>
                                        {selectedSortLabel}
                                    </Text>
                                    <ChevronDownType2
                                        transform={
                                            isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                                        }
                                        transition="transform 0.2s"
                                        {...refinementsStyles.accArrow}
                                    />
                                </Flex>
                            </AccordionButton>
                            <AccordionPanel paddingLeft={0}>
                                <RadioGroup value={selectedSortingOption} {...refinementsStyles.sortingRadioGroup}>
                                    <VStack align="stretch" spacing={4}>
                                        {sortingOptions.map(
                                            (option, index) => (
                                                <Radio
                                                    key={option.id}
                                                    value={option.id}
                                                    onChange={() => {
                                                        history.push(sortUrls[index])
                                                    }}
                                                >
                                                    {option.label}
                                                </Radio>
                                            )
                                        )}
                                    </VStack>
                                </RadioGroup>
                            </AccordionPanel>
                        </>
                    )}
                </AccordionItem>
            </Accordion>
        </>
    )
}

DrawerSort.propTypes = {
    sortingOptions: PropTypes.array,
    sortUrls: PropTypes.array.isRequired,
    selectedSortingOption: PropTypes.string
}

export default DrawerSort
